__turbopack_context__.v({
  "option": "SegmentedControl-module__oHb60a__option",
  "root": "SegmentedControl-module__oHb60a__root",
});
